"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
exports.getStyles = function () {
    return {
        screenReaderText: Styling_1.hiddenContentStyle
    };
};
//# sourceMappingURL=Announced.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Announced/Announced.styles.js
// module id = 671
// module chunks = 0